window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
window.EchoService = {
    init: () => new Echo({
        broadcaster: 'pusher',
        key: window.pusher.key,
        cluster: window.pusher.cluster,
        encrypted: true,
        forceTLS: true,
        host: window.api_host,
        authEndpoint: 'broadcasting/auth',
    })
};


window.cookieManager = {
    set(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
    },
    get(name) {
        const nameEQ = name + "=";
        const cookies = document.cookie.split(";").map(c => c.trim());
        for (const cookie of cookies) {
            if (cookie.indexOf(nameEQ) === 0) {
                return decodeURIComponent(cookie.substring(nameEQ.length));
            }
        }
        return null;
    },
    checkAndSetFirstPageCookie() {
        const cookieName = "firstPageSeen";
        if (!this.get(cookieName)) {
            const currentUrl = window.location.href;
            this.set(cookieName, currentUrl, 60);
        }
    },
    getFirstPageCookie() {
        return this.get("firstPageSeen");
    }
};

// Run cookie logic before app initializes
window.cookieManager.checkAndSetFirstPageCookie();
